<template>
  <form @submit.prevent="submit">
    <Stack>
      <Alert
        v-if="hasAdminAccount"
        title="Admin Account"
        description="The email you entered exists as admin account. Are you trying to login to the Aryeo admin portal?"
      >
        <Button
          text="Go to Admin Login Page"
          color="primary"
          :link="route('web.company.login.show')"
        />
      </Alert>

      <Stack space="xsmall">
        <FormTextInput
          :value="form.email"
          label="Email address"
          name="email"
          type="email"
          autocomplete="username"
          @update:modelValue="updateFormValue"
          :error="form.errors.email"
        />
        <FormTextInput
          :value="form.password"
          label="Password"
          name="password"
          type="password"
          autocomplete="current-password"
          @update:modelValue="updateFormValue"
          :error="form.errors.password"
        />
      </Stack>
      <Columns
        align="stretch"
        alignY="center"
        collapseBelow="md"
        space="gutter"
        :isReversed="[false, false, true]"
      >
        <Column width="content">
          <Button
            :isLoading="form.processing"
            type="submit"
            text="Sign in to your account"
            @click="submit"
          />
        </Column>
        <Column>
          <aryeo-link
            :href="forgotPasswordUrl"
            class="text-sm font-medium text-primary transition duration-150 ease-in-out focus:outline-none focus:underline"
          >
            Forgot your password?
          </aryeo-link>
        </Column>
      </Columns>
    </Stack>
  </form>
</template>

<script setup>
import { router } from '@inertiajs/vue3'
import { Button, Column, Columns, FormTextInput, Stack } from '@aryeo/runway'
import Alert from '@/Runway/Alerts/Simple.vue'

const props = defineProps({
  email: {
    type: String,
    default: null,
  },
  loginUrl: {
    type: String,
    required: true,
  },
  forgotPasswordUrl: {
    type: String,
    required: true,
  },
  hasAdminAccount: {
    type: Boolean,
    default: false,
  },
})

const form = router.form({
  email: props.email,
  password: null,
})

const updateFormValue = ({ key, value }) => {
  let newValue = value

  if (key === 'email') {
    newValue = newValue.toLowerCase()
  }

  form[key] = newValue
}

const submit = () => {
  form.post(props.loginUrl)
}
</script>
